import { cx } from '@/utils/cx';
import styles from '@/styles/components/Status/style.scss';

export type Tone = 'green' | 'amber' | 'blue' | 'yellow' | 'gold' | 'primary' | 'red' | 'grey';

/** Small coloured dot. `hollow` draws a ring (used for "available"). */
export function StatusDot({ tone, hollow, label, className }: { tone: Tone; hollow?: boolean; label?: string; className?: string }) {
  return (
    <span
      className={cx(styles.dot, styles[tone], hollow && styles.hollow, className)}
      role={label ? 'img' : undefined}
      aria-label={label}
      title={label}
      aria-hidden={label ? undefined : true}
    />
  );
}

/** Rounded pill with a dot and label. */
export function StatusPill({ tone, label, hollow }: { tone: Tone; label: string; hollow?: boolean }) {
  return (
    <span className={cx(styles.pill, styles[tone])}>
      <StatusDot tone={tone} hollow={hollow} />
      {label}
    </span>
  );
}

/** Count bubble, e.g. on a nav item or icon button. */
export function CountBadge({ count, floating, className }: { count: number; floating?: boolean; className?: string }) {
  if (count <= 0) return null;
  return <span className={cx(styles.badge, floating && styles.floating, className)}>{count}</span>;
}
